<template>
    <div class="pa-1">
        <div v-if="pageLoading" class="text-center mt-8">
            <v-progress-circular
                    indeterminate
                    size="64"
            ></v-progress-circular>
        </div>
        <div v-else v-for="channelConfiguration in channelConfigurations" :key="channelConfiguration.type" class="mb-6">
            <TabBasic toolbar-color="primary" toolbar-text-color="secondary--text">
                <template v-slot:header>
                    {{ channelConfiguration.label }}
                </template>
                <v-form>
                    <ChannelConfiguration v-model="channelConfigurationsData" :type="channelConfiguration.type"/>
                    <v-row class="mt-3">
                        <v-col class="text-right">
                            <v-btn
                                    :disabled="!hasChanges[channelConfiguration.type]"
                                    class="elevation-5  secondary--text mr-3"
                                    color="primary"
                                    large
                                    @click="resetChannelConfiguration(channelConfiguration.type)">
                                {{ $t('cancel') }}
                            </v-btn>
                            <v-btn
                                    :disabled="!hasChanges[channelConfiguration.type]"
                                    :loading="loading[channelConfiguration.type]"
                                    class="elevation-5 accentText--text"
                                    color="accent"
                                    large
                                    @click="saveChannelConfiguration(channelConfiguration.type)">
                                {{ $t('save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </TabBasic>
        </div>
        <LeaveConfirmDialog ref="leaveConfirmDialog"/>
    </div>
</template>

<script>
import {isEqual} from "@/helper/helper";
import ChannelConfiguration from "@/components/Settings/ChannelConfiguration";
import TabBasic from "@/components/reusable/TabBasic/TabBasic.vue";

export default {
  name: "MyOrganizations",
  components: {TabBasic, ChannelConfiguration},
  mounted() {
    this.initChannelConfiguration();
  },
  data() {
    return {
      channelConfigurationsData: {
        Alert: {
          Email: {
            Info: false,
            Critical: false,
            Warning: false
          },
          SMS: {
            Info: false,
            Critical: false,
            Warning: false
          },
          Realtime: {
            Info: false,
            Critical: false,
            Warning: false
          },
        },
        Notification: {
          Email: {
            Info: false,
            Critical: false,
            Warning: false
          },
          SMS: {
            Info: false,
            Critical: false,
            Warning: false
          },
          Realtime: {
            Info: false,
            Critical: false,
            Warning: false
          },
        },
      },
      oldChannelConfigurationData: {},
      isAdmin: this.$store.getters.isOrganizationAdmin,
      hasChanges: {
        Alert: false,
        Notification: false
      },
      loading: {
        Alert: false,
        Notification: false,
        Settings: false,
      },
      pageLoading: true,
    };
  },
  watch: {
    channelConfigurationsData: {
      handler() {
        this.hasChanges.Alert = !isEqual(this.channelConfigurationsData['Alert'], this.oldChannelConfigurationData['Alert']);
        this.hasChanges.Notification = !isEqual(this.channelConfigurationsData['Notification'], this.oldChannelConfigurationData['Notification']);
      },
      deep: true
    },
  },
  computed: {
    isResetForm() {
      return this.organization.Color !== '#FFFFFF' || this.organization.BackgroundColor !== '#9E0D01' || this.organization.LogoUrl;
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    },
    selectedOrganization() {
      return this.$store.getters.selectedOrganization;
    },
    organizations() {
      return this.$store.getters.getOrganizations;
    },
    channelConfigurations() {
      return [
        {
          type: 'Alert',
          label: this.$t('settings.alerts')
        },
        {
          type: 'Notification',
          label: this.$t('menu.notifications')
        },
      ];
    }
  },
  methods: {
    initChannelConfiguration() {
      const url = this.$store.getters.channelConfiguration;
      this.axios.get(url).then(({data}) => {
        const res = {...data.Result};
        this.oldChannelConfigurationData = JSON.parse(JSON.stringify(this.channelConfigurationsData));
        for (let i = 0; i < data.Result.length; i++) {
          this.channelConfigurationsData[res[i].Type][res[i].Channel][res[i].Severity] = true;
          this.oldChannelConfigurationData[res[i].Type][res[i].Channel][res[i].Severity] = true;
        }
      }).finally(() => {
        this.pageLoading = false;
      })
    },
    resetChannelConfiguration(type) {
      this.channelConfigurationsData[type] = JSON.parse(JSON.stringify(this.oldChannelConfigurationData[type]));
    },
    saveChannelConfiguration(type) {
      let values = [];
      let otherType = 'Alert';
      if (type === 'Alert') {
        otherType = 'Notification';
      }
      for (const [channelKey, channelValue] of Object.entries(this.channelConfigurationsData[type])) {
        for (const [severityKey, value] of Object.entries(channelValue)) {
          if (value) {
            values.push({
              Type: type,
              Channel: channelKey,
              Severity: severityKey
            });
          }
          // Use the old data for the other type, because we want to save the changes only for the selected type.
          if (this.oldChannelConfigurationData[otherType][channelKey][severityKey]) {
            values.push({
              Type: otherType,
              Channel: channelKey,
              Severity: severityKey
            });
          }
        }
      }
      const url = this.$store.getters.channelConfiguration;
      this.loading[type] = true;
      this.axios.put(url, values).then(() => {
        this.oldChannelConfigurationData[type] = JSON.parse(JSON.stringify(this.channelConfigurationsData[type]));
        this.hasChanges[type] = false;
        this.$store.dispatch('addNotification',
            {
              type: 'success',
              message: type === 'Alert' ? this.$t('success.alertsWasUpdated') : this.$t('success.notificationsWasUpdated')
            });
      }).finally(() => {
        this.loading[type] = false;
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges.Alert || this.hasChanges.Notification || this.hasChangesSettings) {
      this.$refs.leaveConfirmDialog.openDialog().then((res) => {
        if (res) {
          next();
        }
        this.next = next;
        next(false);
      });
    } else {
      return next();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "my-organizations";
</style>